import { ArrowUpDown, MapPin, SlidersHorizontal } from "lucide-react";
import { PLP_MAX_WIDTH } from '../../constants';

export function PlpBottomBar({
    pincode,
    onOpenPincode,
    onOpenSort,
    onOpenFilter,
    hidePincode = false,
    variant = "default"
  }: {
    pincode?: string;
    onOpenPincode?: () => void;
    onOpenSort?: () => void;
    onOpenFilter?: () => void;
    hidePincode?: boolean;
    variant?: "default" | "store";
  }) {
    const backgroundColor = variant === "store" ? "var(--store-plp-top-bar-bg)" : "var(--plp-top-bar-bg)";
    const borderTopColor = variant === "store" ? "var(--store-plp-bottom-bar-border)" : "var(--plp-bottom-bar-border)";
    const showPincodeButton = !hidePincode;

    return (
      <div
        className="fixed inset-x-0 bottom-0 z-20 flex items-stretch border-t md:hidden"
        style={{ backgroundColor, borderTopColor }}
      >
        <div className={`mx-auto flex w-full max-w-[${PLP_MAX_WIDTH}px] items-stretch`}>
          {showPincodeButton && (
            <>
              <button
                type="button"
                className="flex flex-1 items-center justify-center gap-2 py-3 text-xs font-medium uppercase tracking-wide text-white"
                onClick={onOpenPincode}
              >
                <MapPin className="h-4 w-4 shrink-0" aria-hidden />
                <span>{pincode || 'Pincode'}</span>
              </button>
              <span className="w-px shrink-0 bg-white/30" aria-hidden />
            </>
          )}
          <button
            type="button"
            className="flex flex-1 items-center justify-center gap-2 py-3 text-xs font-medium uppercase tracking-wide text-white"
            onClick={onOpenSort}
          >
            <ArrowUpDown className="h-4 w-4 shrink-0" aria-hidden />
            <span>Sort</span>
          </button>
          <span className="w-px shrink-0 bg-white/30" aria-hidden />
          <button
            type="button"
            className="relative flex flex-1 items-center justify-center gap-2 py-3 text-xs font-medium uppercase tracking-wide text-white"
            onClick={onOpenFilter}
          >
            <SlidersHorizontal className="h-4 w-4 shrink-0" aria-hidden />
            <span>Filter</span>
          </button>
        </div>
      </div>
    );
  }